export default "__VITE_ASSET__BNE4SzkK__ 430w";